module.exports = __webpack_public_path__ + "media/images/workplace/activity_points/reward_badge_silver-4eb01cecb404953ea888a3a7fef41074.svg";